import Controller from "@ember/controller";
import { action, computed } from "@ember/object";
import { service } from "@ember/service";
import { popupAjaxError } from "discourse/lib/ajax-error";
import { changeEmail } from "discourse/lib/user-activation";

export default class AccountCreatedEditEmailController extends Controller {
  @service router;

  accountCreated;
  newEmail;

  @computed("newEmail", "accountCreated.email")
  get submitDisabled() {
    return this.newEmail === this.accountCreated?.email;
  }

  @action
  updateNewEmail(email) {
    this.set("newEmail", email);
  }

  @action
  async changeEmail() {
    try {
      await changeEmail({ email: this.newEmail });

      this.set("accountCreated.email", this.newEmail);
      this.router.transitionTo("account-created.resent");
    } catch (e) {
      popupAjaxError(e);
    }
  }

  @action
  cancel() {
    this.router.transitionTo("account-created.index");
  }
}
